// @flow
export const monetize = (value: number | string) => {
  return `$${Number(value).toFixed(2)}`;
};
